module.exports = __webpack_public_path__ + "img/register.7b809954.jpg";